<template>
  <!-- <input type="file"
    style="width:100%; height: 100%"
    :disabled="disabled"
    :maxlength="schema.max"
    :placeholder="schema.placeholder"
    :readonly="schema.readonly"
    accept="image/png, image/jpeg" /> -->
<input type="file" name="file" />
</template>

<script>
import { abstractField } from "vue-form-generator";
import vue2Dropzone from "@/components/vue2-dropzone";
import "dropzone/dist/dropzone.css";

export default {
  mixins: [abstractField],
  data() {
    return {
      options: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        headers: { "My-Awesome-Header": "header value" },
      },
    };
  },
  components: {
    vueDropzone: vue2Dropzone,
  },
  mounted() {
    // console.log(this.model[this.schema.model]);
    // this.editor = new JSONEditor(this.$refs.editor, {
    //     search: false,
    //     mainMenuBar: true,
    //     navigationBar: false,
    //     statusBar: false,
    //     onChange: () => {
    //         this.value = this.editor.get();
    //     }
    // });
    // this.editor.set(this.value);
  },
};
</script>

<style></style>
